import Close from '@sats-group/icons/18/close';
import Confirm from '@sats-group/icons/18/confirm';
import Error from '@sats-group/icons/18/error';
import Info from '@sats-group/icons/18/info';
import WarningSign from '@sats-group/icons/18/warning-sign';
import cn from 'classnames';
import React, { useState } from 'react';

import Text from '../text';
import VisuallyHidden from '../visually-hidden';

import type { Banner as Props } from './banner.types';

const typeIcon = {
  error: <Error />,
  information: <Info />,
  neutral: <Info />,
  success: <Confirm />,
  warning: <WarningSign />,
};

const Banner: React.FunctionComponent<Props> = ({
  dismiss,
  icon,
  link,
  list,
  nested,
  text,
  title,
  type,
}) => {
  const [isDismissed, setDismissed] = useState(false);
  if (isDismissed) {
    return null;
  }

  const handleClick = () => setDismissed(true);

  return (
    <div
      className={cn('banner', {
        'banner--layout-dismissable': !icon && dismiss,
        'banner--layout-icon': icon && !dismiss,
        'banner--layout-single': !icon && !dismiss,
        'banner--layout-triple': icon && dismiss,
        'banner--nested': nested,
        [`banner--type-${type}`]: type,
      })}
    >
      {icon ? <div className="banner__icon">{typeIcon[type]}</div> : null}
      <div className="banner__primary">
        {title ? (
          <div className="banner__title">
            <Text theme={Text.themes.emphasis} tight>
              {title}
            </Text>
          </div>
        ) : null}
        <Text className="banner__text" size={Text.sizes.small}>
          {text}
        </Text>
        {list.length ? (
          <Text
            elementName="ol"
            className="banner__list"
            size={Text.sizes.small}
          >
            {list.map(item => (
              <li key={item}>{item}</li>
            ))}
          </Text>
        ) : null}
        {link ? (
          <Text className="banner__link">
            <a className="banner__anchor" href={link.href}>
              {link.text}
            </a>
          </Text>
        ) : null}
      </div>
      {dismiss ? (
        <div className="banner__secondary">
          <button className="banner__dismisser" onClick={handleClick}>
            <VisuallyHidden>{dismiss}</VisuallyHidden>
            <Close />
          </button>
        </div>
      ) : null}
    </div>
  );
};

export default Banner;
